import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../public/icons-v1_1";
import AppButton from "@/features/line-sheet-sets/app-button";

function PathPickBasketNoResult() {
  return (
    <Flex
      flexDirection={"column"}
      gap={"8px"}
      padding={"20px"}
      borderRadius={"8px"}
      border={"0.5px solid #D4D4D1"}
    >
      <CustomIcon
        src={"warning-triangle"}
        width={24}
        height={24}
        color={"#8F8F8C"}
      />
      <Text textStyle={"body-md-bold"} color={"#444444"}>
        아직 담은 상품이 없습니다
      </Text>
      <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
        패스픽에서 상품을 담으면 이 페이지에서 대량으로 검토하고 다운로드 신청할
        수 있습니다.
      </Text>
      <AppButton variant={"primary"} width={"fit-content"}>
        <Text textStyle={"body-sm-bold"}>패스픽으로 이동</Text>
      </AppButton>
    </Flex>
  );
}

export default PathPickBasketNoResult;
